import type { PhoneConfigItem, PhoneConfigUpsert } from '@/types/api';
import { apiFetch } from './client';

export function listPhoneConfigs(): Promise<PhoneConfigItem[]> {
  return apiFetch<PhoneConfigItem[]>('/phone-config');
}

export function getPhoneConfig(phone: string): Promise<PhoneConfigItem> {
  return apiFetch<PhoneConfigItem>(`/phone-config/${encodeURIComponent(phone)}`);
}

export function upsertPhoneConfig(
  phone: string,
  body: PhoneConfigUpsert,
): Promise<PhoneConfigItem> {
  return apiFetch<PhoneConfigItem>(`/phone-config/${encodeURIComponent(phone)}`, {
    method: 'PUT',
    json: body,
  });
}

export function deletePhoneConfig(phone: string): Promise<{ ok: boolean }> {
  return apiFetch<{ ok: boolean }>(`/phone-config/${encodeURIComponent(phone)}`, {
    method: 'DELETE',
  });
}
